module.exports = __webpack_public_path__ + "static/media/info.ebdfc6d6.svg";